import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Spinner, Card, Button } from "@/components/ui";
import Layout from "@/components/Layout";
import { Building2, LogOut } from "lucide-react";

function EmployerNotice() {
  const { user, signOut } = useAuth();
  return (
    <div className="min-h-screen bg-surface flex items-center justify-center p-6">
      <Card className="max-w-md text-center" data-testid="employer-notice">
        <div className="mx-auto w-12 h-12 rounded-full bg-brand-tint flex items-center justify-center mb-4"><Building2 className="w-6 h-6 text-brand-dark" /></div>
        <h1 className="font-display text-2xl text-ink">This is the caregiver app</h1>
        <p className="text-sm text-subtle mt-2">
          You&apos;re signed in as an employer administrator ({user?.email}). Manage your workspace, covered lives, and utilization from the KinBridge Health <span className="font-semibold text-ink">employer portal</span>.
        </p>
        <Button variant="secondary" className="mt-5" data-testid="employer-notice-signout" onClick={signOut}>
          <LogOut className="w-4 h-4" /> Sign out
        </Button>
      </Card>
    </div>
  );
}

export default function ProtectedRoute({ children }) {
  const { ready, user, family, patient } = useAuth();
  if (!ready) return <div className="min-h-screen bg-surface"><Spinner /></div>;
  if (!user) return <Navigate to="/login" replace />;
  // Employer admins belong in the employer portal, not the caregiver app.
  if (user.company_id && !user.employer_covered) return <EmployerNotice />;
  // Caregivers without a family — or with a family but no care recipient yet
  // (paid signup creates the family before onboarding) — must onboard first.
  if (!patient && (!family || !family.loved_one?.name)) return <Navigate to="/onboarding" replace />;
  return <Layout>{children}</Layout>;
}
